/* ===========================================================================
   MM — STICKY CONTACT
   ---------------------------------------------------------------------------
   La barre flottante de contact (sections/MM-Sticky-Contact.liquid).

   1. HISSAGE. main est plafonné à z-index 1 (règle du thème) : la section se
      hisse sur <body> au chargement, même parade que le panier flottant
      (assets/mm-cart-drawer.js). Jamais dans l'éditeur de thème — Shopify y
      tient au DOM de la section pour la sélection et le rechargement.

   2. APPARITION. Un IntersectionObserver regarde la première section de
      #MainContent (le hero — la nôtre est exclue si le gabarit nous a mis
      devant) : tant qu'il touche l'écran la barre est rangée ; dès que son
      bas passe au-dessus du viewport, .is-visible la fait monter. Remonter
      en haut de page la range. Le trajet est en CSS.

   3. FOOTER. Un second observateur regarde le groupe de pied de page : dès
      qu'il entre à l'écran, la barre se range — le geste des filtres sticky,
      qui s'arrêtent au bord de leur conteneur. Le footer a son propre
      contact, la barre n'a plus rien à y faire.

   Dans l'éditeur de thème, la barre est montrée d'office (attribut
   data-mm-stc-editeur posé par le Liquid) : elle se règle à vue.
   =========================================================================== */

(function () {
	'use strict';

	if (window.__mmStickyContact) return;
	window.__mmStickyContact = true;

	function setup() {
		var bar = document.querySelector('[data-mm-stc]');
		if (!bar) return;

		/* Éditeur de thème : visible, pas de hissage, pas d'observation. */
		if (bar.hasAttribute('data-mm-stc-editeur') || (window.Shopify && window.Shopify.designMode)) {
			bar.classList.add('is-visible');
			return;
		}

		/* Hissage de la section entière sur <body>. */
		var sec = bar.closest('.shopify-section') || bar;
		if (sec.parentElement !== document.body) document.body.appendChild(sec);

		/* Le hero : la première section de la page qui n'est pas la nôtre. */
		var hero = null;
		var candidates = document.querySelectorAll('#MainContent .shopify-section');
		for (var i = 0; i < candidates.length; i++) {
			if (candidates[i] !== sec) { hero = candidates[i]; break; }
		}
		// A composed landing may nominate its opening chapter as the hero.
		if (hero) hero = hero.querySelector('[data-mm-stc-hero]') || hero;
		if (!hero || !('IntersectionObserver' in window)) return;

		/* Deux conditions, une seule décision : le hero est passé ET le pied
		   de page n'est pas encore là. */
		var fromStart = bar.hasAttribute('data-mm-stc-from-start');
		var heroPasse = fromStart;
		var footerLa = false;
		function apply() {
			bar.classList.toggle('is-visible', (fromStart || heroPasse) && !footerLa);
		}

		apply();

		new IntersectionObserver(function (entries) {
			var entry = entries[0];
			heroPasse = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
			apply();
		}).observe(hero);

		var footer = (document.querySelector('[data-pos-boutique]') && document.querySelector('.mm-lp-pied')) || document.querySelector('.shopify-section-group-footer-group, footer');
		if (footer) {
			new IntersectionObserver(function (entries) {
				footerLa = entries[0].isIntersecting;
				apply();
			}).observe(footer);
		}
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', setup);
	} else {
		setup();
	}
	/* L'éditeur recharge la section : elle revient dans main, on remontre. */
	document.addEventListener('shopify:section:load', setup);
})();

